<template>
<div class="chapter">
<div class="inner_page">
<h3><span class="un"><b><big>C</big>ONTENTS</b></span></h3>
<p class="paranoindent1"> </p>
<p class="toc-list2"><a href="#/05_Introduction#introduction" id="toc-introduction">Introduction</a></p>
<p class="paranoindent1"> </p>
<p class="toc-list2"><a href="#/06_Chapter1#ch1" id="toc-ch1">1 Brussels and the Garrison towns in 1815</a></p>
<p class="toc-list2"><a href="#/07_Chapter2#ch2" id="toc-ch2">2 Napoleon concentrates at the Front</a></p>
<p class="toc-list2"><span href="#/08_Chapter3#ch3" id="toc-ch3" title="Link target outside of Sample">3 The Outbreak of Hostilities</span></p>
<p class="toc-list2"><span href="#/09_Chapter4#ch4" id="toc-ch4" title="Link target outside of Sample">4 The Battle of Charleroi, 15 June 1815</span></p>
<p class="toc-list2"><span href="#/10_Chapter5#ch5" id="toc-ch5" title="Link target outside of Sample">5 The Calm before the Storm</span></p>
<p class="toc-list2"><span href="#/11_Chapter6#ch6" id="toc-ch6" title="Link target outside of Sample">6 The Preparations for Battle</span></p>
<p class="toc-list2"><span href="#/12_Chapter7#ch7" id="toc-ch7" title="Link target outside of Sample">7 The Battle of Quatre Bras, 16 June 1815</span></p>
<p class="toc-list2"><span href="#/13_Chapter8#ch8" id="toc-ch8" title="Link target outside of Sample">8 The Battle of Ligny, 16 June 1815</span></p>
<p class="toc-list2"><span href="#/14_Chapter9#ch9" id="toc-ch9" title="Link target outside of Sample">9 The Aftermath</span></p>
<p class="toc-list2"><span href="#/15_Chapter10#ch10" id="toc-ch10" title="Link target outside of Sample">10 Waterloo Controversies</span></p>
<p class="toc-list2"><span href="#/16_Chapter11#ch11" id="toc-ch11" title="Link target outside of Sample">11 The Three Armies</span></p>
<p class="toc-list2"><span href="#/17_Chapter12#ch12" id="toc-ch12" title="Link target outside of Sample">12 Tour Guide</span></p>
<p class="toc-list2"><a href="#/18_Orderofbattle#order-of-battle" id="toc-order-of-battle">Orders of Battle, 16 June 1815</a></p>
<p class="paranoindent1"> </p>
<p class="toc-list2"><a href="#/19_Furtherreading#further-reading" id="toc-further-reading">Further Reading</a></p>
<p class="toc-list2"><span href="#/20_Index#index" id="toc-index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?f1e5e790